import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { API } from "@service/system/api.service";
import { AppContent, AppContentUpdateMessage, ProductVersions, ServiceResponse } from "@appcore/data";
import { HttpManager } from "@service/system/httpManager.service";
import { ResponseHandler } from "@service/system/responseHandler.service";

const API_URL = API.API_URL;

@Injectable()
export class AppContentManagerService {
	private apiURL = `${API_URL}/appcontent`;

	constructor(private httpManager: HttpManager, private responseHandler: ResponseHandler) {}

	deleteContentItem(itemID: string): Observable<ServiceResponse<AppContentUpdateMessage[]>> {
		return this.responseHandler.httpDelete<AppContentUpdateMessage[]>(`${this.apiURL}/${itemID}/delete`);
	}

	getContentItems(status: boolean): Observable<ServiceResponse<AppContent[]>> {
		return this.responseHandler.httpGet<AppContent[]>(`${this.apiURL}`, { active: status });
	}

	getContentItemByItemID(itemID: string): Observable<ServiceResponse<AppContent[]>> {
		return this.responseHandler.httpGet<AppContent[]>(`${this.apiURL}/${itemID}`);
	}

	getContentItemsByProductVersionItemID(pvItemID: string): Observable<ServiceResponse<AppContent[]>> {
		return this.responseHandler.httpGet<AppContent[]>(`${this.apiURL}/related/${pvItemID}`);
	}

	getProductVersionListing(): Observable<ServiceResponse<ProductVersions[]>> {
		return this.responseHandler.httpGet<ProductVersions[]>(`${this.apiURL}/productversions`)
	}

	createContentItem(userID: string): Observable<ServiceResponse<string>> {
		userID = userID == null ? "" : userID;
		return this.responseHandler.httpPost<string>(`${this.apiURL}/create`, null, { createdBy: userID });
	}

	setContentItem(itemID: string, body: any): Observable<ServiceResponse<AppContentUpdateMessage[]>> {
		return this.responseHandler.httpPost<AppContentUpdateMessage[]>(`${this.apiURL}/${itemID}/set`, body);
	}

	uploadContentItemFile(itemID: string, body: any): Observable<AppContentUpdateMessage> {
		return this.httpManager.httpPostMediaFile<AppContentUpdateMessage>(
			`${this.apiURL}/${itemID}/uploadAppContentResource`,
			body
		);
	}
}
